// eslint-disable-next-line
import util from 'util';

import * as PortalApi from '../PortalApi';

export function queryAccount(successHandler, errorHandler, accountId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId);
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function queryInvoice(successHandler, errorHandler, accountId, invoiceId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/invoices/' + encodeURIComponent(invoiceId);
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function queryPaymentMethods(successHandler, errorHandler, accountId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/paymentMethods';
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function createPaymentMethod(successHandler, errorHandler, accountId, paymentMethodUid, activate) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/paymentMethods';
  let form = PortalApi.makeForm({paymentMethodUid, activate});
  PortalApi.call(url,
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

export function deletePaymentMethod(successHandler, errorHandler, accountId, paymentMethodUid) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/paymentMethods/' +
            encodeURIComponent(paymentMethodUid);
  PortalApi.call(url, {method : 'delete' }, successHandler, errorHandler);
}

export function savePaymentMethod(successHandler, errorHandler, accountId, paymentMethodUid, month, year) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/paymentMethods/' +
            encodeURIComponent(paymentMethodUid);
  let form = PortalApi.makeForm({month, year});
  PortalApi.call(url,
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

export function payInvoice(successHandler, errorHandler, accountId, invoiceId, paymentMethodUid, amount, surchargeMetadata, agentUserSession) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/invoices/' + encodeURIComponent(invoiceId);
  let form = PortalApi.stringifyJson({paymentMethodUid, amount, agentUserSession, surchargeMetadata: {...surchargeMetadata}});
  PortalApi.call(url,
                 {method : 'post', body: form, headers: {
                     "Content-Type": "application/json",
                     "Accept": "application/json",
                   }},
                 successHandler, errorHandler);
}

export function enableAutopay(successHandler, errorHandler, accountId, paymentMethodUid) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/autopay';
  let form = PortalApi.makeForm({autopay : 'Y', paymentMethodUid});
  PortalApi.call(url,
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

export function disableAutopay(successHandler, errorHandler, accountId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/autopay';
  let form = PortalApi.makeForm({autopay : 'N'});
  PortalApi.call(url,
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}


export function requestCallerId(successHandler, errorHandler, accountId, phoneNumber) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/requestCallerid';
  let form = PortalApi.makeForm({phoneNumber});
  PortalApi.call(url,
                 {method : 'post', body: form },
                 successHandler, errorHandler);
}

export function removeCallerId(successHandler, errorHandler, accountCalleridId) {
  let url = '/api/callerids/' + encodeURIComponent(accountCalleridId);
  PortalApi.call(url, {method : 'delete'}, successHandler, errorHandler);
}

export function getCallSummaryStats(successHandler, errorHandler, accountId,invoiceId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId)+'/reports/current?invoiceId='+encodeURIComponent(parseInt(invoiceId) === -1 ? 0 : invoiceId );
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function getCombinedCallSummaryStats(successHandler, errorHandler, accountId,invoiceId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId)+'/combinedReports/current?invoiceId='+encodeURIComponent(parseInt(invoiceId) === -1 ? 0 : invoiceId );
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function getPhoneNumberInsights(successHandler, errorHandler, accountId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId)+'/reports/phoneNumberInsights';
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function getCallVolumeBarData(successHandler, errorHandler, accountId,invoiceId, type) {
  let url = '/api/accounts/' + encodeURIComponent(accountId)+'/reports/callVolume?invoiceId='+encodeURIComponent(parseInt(invoiceId) === -1 ? 0 : invoiceId );
  if(type !== undefined){
    url += '&type=' + type;
  }
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function getContactInsightsWeeklyData(successHandler, errorHandler, accountId,invoiceId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/reports/contactInsights?invoiceId='+encodeURIComponent(parseInt(invoiceId) === -1 ? 0 : invoiceId );
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function getTasksByInvoice(successHandler, errorHandler, accountId,invoiceId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/reports/' + encodeURIComponent(parseInt(invoiceId) === -1 ? 0 : invoiceId )+'/tasks';
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function queryChatsByAccount(successHandler, errorHandler, accountId) {
  let url = '/api/leads';
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function getPlaidLinkToken(successHandler, errorHandler, accountId) {
  // let url = '/api/plaid/token/' + encodeURIComponent(accountId);
  // PortalApi.call(url, {}, successHandler, errorHandler);
}

export function attachPlaidToken(successHandler, errorHandler, accountId, publicToken, bankAccountId, activate) {
  // let url = '/api/plaid/attach/' + encodeURIComponent(accountId);
  // let form = PortalApi.makeForm({publicToken, bankAccountId, activate});
  // PortalApi.call(url,
  //                {method : 'post', body: form },
  //                successHandler, errorHandler);
}

export function getSetupIntent(successHandler, errorHandler, accountId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/stripeSetupIntent';
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function queryBillingEmails(successHandler, errorHandler, accountId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/billingEmails';
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function addBillingEmail(successHandler, errorHandler, accountId, address) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/billingEmails';
  let form = PortalApi.makeForm({name: 'Additional Email', address});
  PortalApi.call(url, {method: 'post', body: form}, successHandler, errorHandler);
}

export function deleteBillingEmail(successHandler, errorHandler, accountId, destinationId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/billingEmails/' +
            encodeURIComponent(destinationId);
  PortalApi.call(url, {method: 'delete'}, successHandler, errorHandler);
}

export function updateBillingEmail(successHandler, errorHandler, accountId, destinationId, address) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/billingEmails/' +
            encodeURIComponent(destinationId);
  let form = PortalApi.makeForm({address});
  PortalApi.call(url, {method: 'post', body: form}, successHandler, errorHandler);
}

/*
 * Update an account
 */
export function updateAccount(successHandler, errorHandler, account, changeSummary) {
  let url = '/api/accounts/' + encodeURIComponent(account.accountId);
  let form = PortalApi.makeForm({ ...account,
                                changeSource : 'AGENT',
                                changeSummary : changeSummary });
  PortalApi.call(url, { method: 'post',
                      body : form,
                      headers: {
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                      }},
               successHandler, errorHandler, 'Update Account');
}

export function getCheckoutSession(successHandler, errorHandler, accountId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/stripeCheckout';
  PortalApi.call(url, {}, successHandler, errorHandler);
}

export function downloadPdfInvoice(successHandler, errorHandler, accountId, invoiceId) {
  let url = '/api/accounts/' + encodeURIComponent(accountId) + '/invoices/' + encodeURIComponent(invoiceId);
  PortalApi.call(url, {}, successHandler, errorHandler);
}

/*
 * Get the payment surcharge prompt
 */
export function queryPaymentSurcharge(successHandler, errorHandler, accountId, invoiceId, paymentMethodUid, amount) {
  let form = PortalApi.makeForm({amount, invoiceId, paymentMethodUid});
  PortalApi.call(`/api/accounts/${encodeURIComponent(accountId)}/surcharge`, {method: 'post',
                   body: form,
                   headers: {
                     "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                   }},
                 successHandler, errorHandler);
}
